import { Wrapper } from "@googlemaps/react-wrapper";
import * as qs from "qs";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { MAP_KEY } from "../helpers/constants";
import Loader from "./Loader";
import { Circle } from "./maps/Circle";
import GoogleMap from "./maps/GoogleMap";
import { Marker } from "./maps/Marker";
import NotFound from "./NotFound";

//job map
const JobsMap = () => {
  const location = useLocation();
  const [center, setCenter] = useState(null);
  const [markerMeta, setMarkerMetas] = useState([]);
  const [status, setStatus] = useState("LOADING");
  const [zoom, setZoom] = useState(9);
  const [radius, setRadius] = useState(9);
  const [showCircle, setShowCircle] = useState(false);

  const render = (status) => {
    return <Loader />;
  };

  useEffect(() => {
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (params.zoom) {
      const zoomInNumber = Number(params.zoom);
      if (!isNaN(zoomInNumber)) {
        setZoom(zoomInNumber);
      }
    }

    if (params.m) {
      const positions = decodeURIComponent(params.m)
        .split(",")
        .map((p) => {
          try {
            const meta = p.split(":");
            if (meta.length === 3 && !isNaN(meta[0]) && !isNaN(meta[1])) {
              return {
                lat: Number(meta[0]),
                lng: Number(meta[1]),
                label: meta[2],
              };
            }
          } catch (e) {}

          return null;
        })
        .filter((p) => p !== null);

      setMarkerMetas(positions);

      if (params.circle && params.radius) {
        //in km
        const radiusInMeter = Number(params.radius);
        if (!isNaN(radiusInMeter)) {
          setRadius(radiusInMeter * 1000);
          setShowCircle(true);
        }
      }

      let centerFound = false;
      if (params.center) {
        const latLong = params.center.split(":");
        const lat = Number(latLong[0]);
        const lng = Number(latLong[1]);

        if (latLong.length === 2 && !isNaN(lat) && !isNaN(lng)) {
          setCenter({
            lat,
            lng,
          });
          centerFound = true;
        }
      }

      if (!centerFound && positions.length > 0) {
        setCenter(positions[0]);
      }
    }
  }, []);

  return (
    <Wrapper
      apiKey={MAP_KEY}
      render={render}
      callback={(status) => setStatus(status)}
    >
      <Container fluid className="h-100">
        <Row className="h-100">
          <Col>
            {center && status === "SUCCESS" ? (
              <>
                <GoogleMap
                  center={center}
                  zoom={zoom}
                  mapTypeControl={true}
                  mapTypeControlOptions={{
                    mapTypeIds: ["roadmap", "satellite"],
                  }}
                >
                  {markerMeta &&
                    markerMeta.map((p, index) => (
                      <Marker position={p} infoWindowContent={p["label"]} />
                    ))}
                  {showCircle && (
                    <Circle
                      strokeColor="#FF0000"
                      strokeOpacity={0.3}
                      strokeWeight={1}
                      fillColor="#FF0000"
                      fillOpacity={0.05}
                      center={center}
                      radius={radius}
                    />
                  )}
                </GoogleMap>
              </>
            ) : (
              <NotFound
                text={!center ? "Nothing to show" : "Something went wrong"}
              />
            )}
          </Col>
        </Row>
      </Container>
    </Wrapper>
  );
};

export default JobsMap;
